// Утилита для управления title страниц
export class TitleManager {
  private static readonly DEFAULT_TITLE = 'Школа экспорта РЭЦ';
  private static readonly TITLE_SEPARATOR = ' | ';

  /**
   * Устанавливает title страницы
   * @param pageTitle - название страницы
   * @param includeDefault - включать ли название сайта по умолчанию
   */
  static setTitle(pageTitle?: string, includeDefault: boolean = true): void {
    let title = '';
    
    if (pageTitle) {
      title = includeDefault 
        ? `${pageTitle}${this.TITLE_SEPARATOR}${this.DEFAULT_TITLE}`
        : pageTitle;
    } else {
      title = this.DEFAULT_TITLE;
    }
    
    document.title = title;
  }

  /**
   * Получает title по умолчанию
   */
  static getDefaultTitle(): string {
    return this.DEFAULT_TITLE;
  }

  /**
   * Получает название страницы из title (убирает название сайта)
   */
  static getPageTitleFromDocument(): string {
    const currentTitle = document.title;
    const separatorIndex = currentTitle.indexOf(this.TITLE_SEPARATOR);
    
    if (separatorIndex !== -1) {
      return currentTitle.substring(0, separatorIndex);
    }
    
    return currentTitle === this.DEFAULT_TITLE ? '' : currentTitle;
  }
}
